document.addEventListener('DOMContentLoaded', (e) => {

    const blocks = document.querySelectorAll('.block--post-listing');

    const postListings = {

        block: null,
        loaded: true,
        page: 1,
        perPage: 12,

        init: (block) => {
            postListings.block = block

            // check filters and if any have dataset.ifActive set to true, then update the URL with the filter
            const filters = block.querySelectorAll('.filter .dropdown-item');
            let presetFilters = [];
            filters.forEach(filter => {
                if (filter.dataset.isActive === 'true') {
                    presetFilters.push(filter);
                }
            });

            if (presetFilters.length > 0) {
                let url = new URL(window.location);
                let params = new URLSearchParams(url.search);

                presetFilters.forEach(filter => {
                    postListings.params(filter.dataset.filterType, filter.dataset.filterValue);

                    postListings.filtered(block, filter.dataset.filterType, filter.dataset.filterValue, filter.innerText);

                    filter.removeAttribute('data-if-active');
                });

                block.scrollIntoView();
            }


            // check for url params on page load and set filters
            let url = new URL(window.location);
            let params = new URLSearchParams(url.search);

            params.forEach((value, key) => {
                // if (key == 'category' || key == 'post_tag' || key == 'keyword') {
                let values = value.split(',');
                values.forEach(value => {

                    if (value) {
                        let text = '';

                        let filter = block.querySelector('.filter .dropdown-item[data-filter-value="' + value + '"]');
                        if (!filter) {
                            filter = block.querySelector('.filter .dropdown-item[data-filter-value-id="' + value + '"]');
                        }

                        if (filter) {

                            text = filter.innerText;

                            // if (key == 'category' || key == 'post_tag') {
                            //     text = block.querySelector('[data-filter-type="' + key + '"][data-filter-value="' + value + '"]')?.innerText;
                            // } else {
                            //     text = value
                            // }

                            if (text) {
                                postListings.filtered(block, key, value, text)
                            }

                        }
                    }
                })
                // }
            });

            // add event listeners for all dropdown items
            let dropdowns = block.querySelectorAll('.filter .dropdown');
            dropdowns.forEach(filter => {
                postListings.dropdowns(block, filter);
            });

            let keyword = block.querySelector('#keyword');
            postListings.keyword(block, keyword);

            // additional listeners and load the posts
            postListings.submit(block);
            postListings.reset(block);
            postListings.more(block);

            postListings.load(block);
        },

        params: (type, value) => {

            let url = new URL(window.location);
            let param = (url.searchParams.get(type)) ? url.searchParams.get(type).split(',') : [];

            if (!param.includes(value)) {
                param.push(value);
                url.searchParams.set(type, param.join(','));
                url.search = decodeURIComponent(url.search);
                window.history.replaceState({}, '', url);
            }
        },

        dropdowns: (block, filter) => {

            let toggle = filter.querySelector('.dropdown-toggle');
            let options = filter.querySelectorAll('.dropdown-item');

            options.forEach(option => {

                option.addEventListener('click', function (e) {
                    // e.currentTarget.classList.add('disabled');

                    let type = e.target.dataset.filterType;
                    let value = e.target.dataset.filterValue;
                    let text = e.target.innerText;
                    postListings.filtered(block, type, value, text)
                })

                option.addEventListener('keydown', function (e) {
                    if (e.key === 'Enter') {
                        // e.currentTarget.classList.add('disabled');

                        let type = e.target.dataset.filterType;
                        let value = e.target.dataset.filterValue;
                        let text = e.target.innerText;
                        postListings.filtered(block, type, value, text);
                        toggle.focus();
                        toggle.setAttribute('aria-expanded', 'false');
                    }
                });
            });

        },

        keyword: (block, keyword) => {

            keyword.addEventListener('keydown', function (event) {
                if (event.key === 'Enter') {
                    let type = 'keyword';
                    let value = keyword.value;
                    let text = keyword.value;

                    if (keyword.value !== '') {
                        keyword.value = '';
                        postListings.loaded = false;
                        postListings.page = 1;
                        postListings.filtered(block, type, value, text);
                    }
                }
            });
        },

        filtered: (block, type, value, text) => {

            let filtered = block.querySelector('.filtered');
            let filter = filtered.querySelector('[data-filter-type="' + type + '"][data-filter-value="' + value + '"]');

            if (!filter) {

                const button = document.createElement('button');
                button.classList.add('btn', 'btn-primary', 'btn-filter');
                button.setAttribute('data-filter-type', type);
                button.setAttribute('data-filter-value', value);
                button.innerText = text;

                button.addEventListener('click', (e) => {

                    let url = new URL(window.location);
                    let param = url.searchParams.get(e.target.dataset.filterType);

                    if (param) {
                        let values = param.split(',');
                        values = values.filter(value => value !== e.target.dataset.filterValue);
                        values = values.join(',');

                        if (values != '') {
                            url.searchParams.set(e.target.dataset.filterType, values);
                        } else {
                            url.searchParams.delete(e.target.dataset.filterType);
                        }

                        window.history.replaceState(null, '', url);
                    }

                    e.target.remove();
                    postListings.loaded = false;
                    postListings.page = 1;
                    postListings.load(block);
                })

                filtered.appendChild(button);

                if (block.dataset.init === 'true') {
                    return;
                }

                postListings.loaded = false;
                postListings.page = 1;
                postListings.params(type, value);
                postListings.load(block);
            }

        },

        submit: (block) => {

            let submit = block.querySelector('.filter-submit');
            let keyword = block.querySelector('#keyword');

            submit?.addEventListener('click', function (e) {
                e.preventDefault();
                let type = 'keyword';
                let value = keyword.value;
                let text = keyword.value;

                if (keyword.value !== '') {
                    keyword.value = '';
                    postListings.loaded = false;
                    postListings.page = 1;
                    postListings.filtered(block, type, value, text);
                }
            })
        },

        reset: (block) => {

            block.addEventListener('click', function (e) {
                if (e.target.classList.contains('filter-reset')) {
                    let url = new URL(window.location);
                    url.search = '';

                    window.history.replaceState({}, '', url);

                    let filtered = block.querySelector('.filtered');
                    filtered.innerHTML = '';

                    postListings.loaded = false;
                    postListings.page = 1;
                    postListings.load(block);
                }
            })
        },

        more: (block) => {

            block.addEventListener('click', function (e) {

                if (e.target.classList.contains('load-more')) {
                    postListings.loaded = true;
                    postListings.page = postListings.page + 1;
                    postListings.load(block);
                }
            })

        },

        pagination: (pagination) => {
            // let self = this;

            pagination = JSON.parse(pagination);

            let totalPages = pagination.totalPages;
            let currentPage = pagination.currentPage;

            const paginationContainer = postListings.block.querySelector('.pagination');
            if(!paginationContainer) return;

            paginationContainer.innerHTML = '';
            paginationContainer.classList.remove('d-none');

            if (totalPages > 1) {

                // add previous arrow
                if (currentPage > 1) {

                    const prevLink = document.createElement('a');
                    prevLink.classList.add('page-link');
                    prevLink.setAttribute('href', window.location.href.split('?')[0] + 'page/' + (currentPage - 1));
                    prevLink.setAttribute('data-page', currentPage - 1);
                    prevLink.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="25" viewBox="0 0 15 25" fill="none"><path d="m12.5 2-10.5 10.5 10.5 10.5" fill="none" stroke="currentColor" stroke-width="3"/></svg>';

                    paginationContainer.appendChild(prevLink);
                }

                const range = 2; // The range of pages around the current page
                let start = currentPage - range;
                let end = currentPage + range;

                if (start < 1) {
                    start = 1;
                    end = start + range * 2;
                }

                if (end > totalPages) {
                    end = totalPages;
                    start = end - range * 2;
                    if (start < 1) start = 1;
                }

                if (totalPages <= range * 2) {
                    for (let i = 1; i <= totalPages; i++) {
                        appendPageItem(i, currentPage);
                    }
                } else {

                    if (start > 2) {
                        appendPageItem(1, currentPage);
                        appendPageItem('...', currentPage);
                    } else if (start === 2) {
                        appendPageItem(1, currentPage);
                    }

                    for (let i = start; i <= end; i++) {
                        appendPageItem(i, currentPage);
                    }

                    if (end < totalPages - 1) {
                        appendPageItem('...', currentPage);
                        appendPageItem(totalPages, currentPage);
                    } else if (end === totalPages - 1) {
                        appendPageItem(totalPages, currentPage);
                    }
                }

                function appendPageItem(page, currentPage) {
                    const paginationItem = document.createElement('a');
                    paginationItem.classList.add('page-link');
                    paginationItem.setAttribute('href', window.location.href.split('?')[0] + 'page/' + page);
                    paginationItem.setAttribute('data-page', page);
                    paginationItem.innerText = page

                    if (page === currentPage) {
                        paginationItem.classList.add('active');
                    }

                    paginationContainer.appendChild(paginationItem);
                }

                // add next arrow
                if (currentPage != totalPages) {

                    const nextLink = document.createElement('a');
                    nextLink.classList.add('page-link');
                    nextLink.setAttribute('href', window.location.href.split('?')[0] + 'page/' + (currentPage + 1));
                    nextLink.setAttribute('data-page', currentPage + 1);
                    nextLink.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="25" viewBox="0 0 15 25" fill="none"><path d="M2 23L12.5 12.5L2 2" stroke="currentColor" stroke-width="3"/></svg>';

                    paginationContainer.appendChild(nextLink);
                }

                const paginationItems = postListings.block.querySelectorAll('.page-link');
                paginationItems.forEach(item => {

                    if (item.dataset.page != '...') {

                        item.addEventListener('click', (e) => {
                            e.preventDefault();

                            const target = postListings.block.querySelector('.post-listing-target');
                            target.innerHTML = '';

                            postListings.loaded = true;
                            postListings.page = e.currentTarget.dataset.page;
                            postListings.load(postListings.block);
                            postListings.block.scrollIntoView();
                        });
                    } else {
                        item.classList.add('disabled');
                    }
                });
            }
        },

        pageItem: function (page, currentPage) {

            const item = document.createElement('a');
            item.classList.add('page-link');
            item.setAttribute('href', '#');
            item.setAttribute('data-page', page);
            item.innerText = page;

            if (page === currentPage) {
                item.classList.add('active');
            }

            return item;
        },

        load: (block) => {

            let spinner = block.querySelector('.spinner');
            let target = block.querySelector('.post-listing-target');
            const filterBar = block.querySelector('.filter-bar');
            const perPage = block.querySelector('#perpage');
            const pagination = postListings.block.querySelector('.pagination');

            // if (pagination)
            //     pagination.innerHTML = '';

            if (perPage) {
                postListings.perPage = perPage.value;
            }

            let more = block.querySelector('.load-more');
            if (more) {
                more.disabled = true;
                more.classList.remove('d-block');
            }

            if (!postListings.loaded) {
                target.innerHTML = '';
            }

            let filtereds = []
            let filters = block.querySelectorAll('.btn-filter');

            if (filters.length != 0) {
                block.querySelector('.filter-reset').classList.remove('d-none')
            } else {
                block.querySelector('.filter-reset').classList.add('d-none')
            }

            filters.forEach(item => {

                const obj = {
                    type: item.dataset.filterType,
                    value: item.dataset.filterValue
                }

                filtereds.push(obj);
            });

            const displayOptions = {};
            for (let i = 0; i < block.attributes.length; i++) {
                const attr = block.attributes[i];
                if (attr.name.startsWith('data-lvl-')) {
                    let name = attr.name.replace('data-lvl-', '');
                    displayOptions[name] = attr.value;
                }
            }

            spinner.style.display = 'block';

            const data = new FormData();

            data.append('filters', JSON.stringify(filtereds));
            data.append('action', 'lvl_block_post_listing_get');
            data.append('nonce', lvl_block_post_listing_ajax.nonce);
            data.append('page', postListings.page);
            data.append('current_id', block.dataset.postId);
            data.append('post_types', filterBar.dataset?.postTypes);
            data.append('is_disable_click', block.dataset?.disableClick);
            data.append('event_status', block.dataset?.eventStatus);
            data.append('posts_per_page', postListings.perPage);
            data.append('display_options', JSON.stringify(displayOptions));
            data.append('link_text', block.dataset.linkText);
            data.append('featured_posts', block.dataset.featuredPosts);
            data.append('card_layout', block.dataset.cardLayout);
            data.append('show_count', block.dataset.showCount);

            if (window.location.pathname.includes('/author/')) {
                const authorName = window.location.pathname.split('/author/')?.pop()?.replace('/', '');
                data.append('author', authorName);
            }

            fetch(lvl_block_post_listing_ajax.ajax_url, {
                method: 'POST',
                credentials: 'same-origin',
                body: data
            }).then((response) => {

                if (!response.ok) {
                    postListings.log('Error getting posts');
                    return;
                }

                return response;
            }).then((response) => {

                if (more) {
                    if (response?.headers?.get('loadmore')) {
                        more.classList.add('d-block');
                        more.disabled = false;
                    } else {
                        more.classList.remove('d-block');
                        more.disabled = true;
                    }
                }

                // if( this.perPage == 0 ) {
                if (pagination) {
                    postListings.pagination(response.headers.get('pagination'));
                }

                return response?.text();
            }).then((data) => {

                if (block.dataset.init === 'false') {
                    if (postListings.loaded) {
                        target.innerHTML += data;
                    } else {
                        target.innerHTML = data;
                    }
                }

                block.dataset.init = 'false';

                postListings.listeners();

                spinner.style.display = 'none';
            }).then(() => {
                const event = new Event('lvl-stretch-links');
                document.dispatchEvent(event);
            }).then(() => {
                // change --loading to --loaded with a 100ms delay per index
                const cards = block.querySelectorAll('.--loading');
                cards.forEach(function (card, index) {
                    setTimeout(function () {
                        card.classList.remove('--loading');
                        card.classList.add('--loaded');

                        // setTimeout(function () {
                        //     card.classList.remove('--loaded');
                        // }, index * 100 + (index < 20 ? 250 : 50));

                    }, index * 100);
                });
            }).then(() => {
                //set min-height on container equal to the first card height
                const card = block.querySelector('.card');
                if (card) {
                    const cardHeight = card.offsetHeight;
                    target.style.minHeight = cardHeight + 'px';
                }
            });

        },

        reload: (block) => {
            // clear listing and reload posts
            let target = block.querySelector('.post-listing-target');
            target.innerHTML = '';
            postListings.loaded = false;
            postListings.page = 1;
            postListings.load(block);
        },

        listeners: () => {

            let cards = postListings.block.querySelectorAll('.card');

            cards.forEach(card => {

                // let link = card.querySelector('a');
                //
                // if (link) {
                //
                // 	card.classList.add('linked');
                // 	card.addEventListener('click', function (e) {
                // 		// left mouse button clicked
                // 		if (e.button === 0) {
                //
                // 			if (e.ctrlKey || e.metaKey) {
                // 				let tabLink = document.createElement('a');
                // 				tabLink.setAttribute('aria-hidden', 'true');
                // 				tabLink.href = link.href;
                // 				tabLink.target = '_blank';
                // 				tabLink.click();
                // 			} else {
                // 				link.click();
                // 			}
                // 		}
                // 	});
                //
                // 	card.addEventListener('auxclick', function (e) {
                // 		// middle mouse button clicked
                // 		if (e.button === 1) {
                // 			e.preventDefault();
                // 			let tabLink = document.createElement('a');
                // 			tabLink.setAttribute('aria-hidden', 'true');
                // 			tabLink.href = link.href;
                // 			tabLink.target = '_blank';
                // 			tabLink.click();
                // 		}
                // 	});
                // }
            });
        },

        log: (message) => {
            console.log(message);
        }
    }

    blocks.forEach(block => {
        postListings.init(block);
    });

    // Editor
    // if (typeof wp !== 'undefined' && wp.data !== undefined) {
    //     const processedBlocks = new Set();
    //
    //     wp.data.subscribe(function () {
    //         const blocks = document.querySelectorAll('.block--post-listing');
    //         blocks.forEach(block => {
    //             if (!processedBlocks.has(block)) {
    //                 postListings.init(block);
    //                 processedBlocks.add(block);
    //
    //                 const observer = new MutationObserver((mutations) => {
    //                     mutations.forEach((mutation) => {
    //                         if (mutation.type === 'attributes') {
    //                             if (mutation.attributeName.startsWith('data-')) {
    //                                 clearTimeout(postListings.timeout);
    //                                 postListings.timeout = setTimeout(() => {
    //                                     postListings.reload(block);
    //                                 }, 1000);
    //                             }
    //                         }
    //                     });
    //                 });
    //
    //                 observer.observe(block, {
    //                     attributes: true
    //                 });
    //             }
    //         });
    //     });
    // }
});